// root landing — placeholder, linking to /mod

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

const Landing = () => (
	<div style={{padding: '3rem 2rem', maxWidth: '40rem'}}>
		<h1 style={{fontSize: '1.25rem', fontWeight: 500, marginBottom: '0.25rem'}}>tsm</h1>
		<p style={{color: '#666', fontSize: '0.875rem', marginBottom: '2rem'}}>
			typescript monorepo
		</p>
		<a href="/mod" style={{color: '#7aa2f7', fontSize: '0.875rem'}}>
			browse mods →
		</a>
	</div>
)

const container = document.getElementById('root')
if (container) {
	createRoot(container).render(
		<StrictMode>
			<Landing />
		</StrictMode>,
	)
}
